import { render, staticRenderFns } from "./CoursesOptions.vue?vue&type=template&id=545653ea"
import script from "./CoursesOptions.vue?vue&type=script&lang=js"
export * from "./CoursesOptions.vue?vue&type=script&lang=js"
import style0 from "./CoursesOptions.vue?vue&type=style&index=0&id=545653ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports